import React, { Fragment } from "react";
import { Grid, Drawer, TextField } from "@material-ui/core";
import moment from 'moment';
import { DrawerNotesItem } from "./DrawerNotesItem";
import { StyledPrimaryButton, StyledInfo, PaddedWrapper, NoteHeader, Title, EmptyNoteWrapper, ImageContainer, NoNotesTextWrapper } from './DrawerNotesStyles';

const emptyNote = `/images/EmptyNote.png`;

export class DrawerNotes extends React.Component {
  state = {
    newNote: ""
  };

  isLast = (index, noteCount) => index === noteCount - 1;

  handleChange = (name, data) => this.setState({ newNote: data.value });

  saveNote = () => {
    if (this.state.newNote && this.state.newNote.note != "") {
      this.props.onAdd(this.state.newNote);
      this.setState({ newNote: "" });
    }
  };

  emptyNoteContainer = () => {
    return <>
      <EmptyNoteWrapper>
        <ImageContainer>
          <img src={emptyNote} />
        </ImageContainer>
      </EmptyNoteWrapper>
      <br />
      <NoNotesTextWrapper>No notes attached to this deal</NoNotesTextWrapper>
    </>
  }

  createNote = (note, index, noteCount) => {
    const { onRemove, authentication } = this.props;
    const isLast = this.isLast(index, noteCount);

    if(authentication.isGuest && note.isPrivate) return null;
    return (
      <Fragment key={index}>
        <DrawerNotesItem
          authentication={authentication}
          note={note}
          onRemove={onRemove}
          updateNote={this.props.onUpdate}
        />
      </Fragment>
    );
  };

  render() {
    const { notes, isOpen, closeDrawer, type } = this.props;
    return (
      <Fragment>
        <Drawer
          onClose={closeDrawer}
          anchor="right"
          open={isOpen}
          style={{ width: "576px" }}
        >
          <PaddedWrapper>
            <NoteHeader>
              <Grid container>
                <Grid item xs={12}>
                  <Title>Notes</Title>
                </Grid>
                <Grid item xs={10}>
                  <StyledInfo>
                    {`
                      Write and attach a note to this ${type}. 
                      The note is only accessible to users within
                      your company unless you make it public after saving.
                    `}
                  </StyledInfo>
                </Grid>
              </Grid>
            </NoteHeader>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <TextField
                id="newNoteField"
                multiline
                fullWidth
                value={this.state.newNote}
                label="Write a note to attach to this deal"
                onChange={event => this.handleChange("newNote", event.target)}
              />
              <StyledPrimaryButton size={"sm"} label={"Save Note"} onClick={this.saveNote} />
            </div>

            {notes && notes.length > 0 &&
              <Grid container direction="column" id="notesList">
                {notes.sort((a, b) => moment.utc(b.createdAt).unix() - moment.utc(a.createdAt).unix()).map((x, i) => {
                  return this.createNote(x, i, notes.length)
                })}
              </Grid>
            }

            {notes && notes.length === 0 && <Grid container direction="column" id="notesList" alignItems={'center'}>
              {this.emptyNoteContainer()}
            </Grid>}

          </PaddedWrapper>
        </Drawer>
      </Fragment>
    );
  }
}